// Global Shoplift Test JS


/*==============================================================================
TEST ID: [CHS-126] [Sitewide] Menu Reduce L2 Spacing [MOB]
PLATFORM: Shoplift
DATE: 06/2026

GOAL:
Inside Mobile menu, Reduce marging spacing between L2 links

KEY INSIGHT:
N/A

BEHAVIOR:
- [MANUAL TRIGGER] runs only when mobile menu is openned
- Inserts CSS <style> into the page's HTML
==============================================================================*/
// Initialize test
async function initTestCHS_126() {
    
    // Configuration
    const TEST_ID = 'CHS126';
    const HYPOTHESIS_ID = '019e5065-73b5-73ae-88a3-9cf8fc430bb7';
    let variantResult = null;

    // Prevent multiple executions
    if (window.__CHS126_HAS_RUN === true) {
        return;
    }

    // Find mobile menu drawer (<details>)
    var drawerDetails = document.getElementById('Details-menu-drawer-container');

    if (!drawerDetails) {
        return;
    }

    // Function to run test AFTER menu opens
    async function handleMenuOpen() {

        // Prevent multiple executions
        if (window.__CHS126_HAS_RUN === true) {
            return;
        }

        window.__CHS126_HAS_RUN = true;

        try {
            // :white_check_mark: Assignment happens ONLY after user opens menu
            variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

            if (variantResult) {

                // Create or reuse the canonical style CSS (append-safe)
                const STYLE_ID = `${TEST_ID}-CSS`;
                let style = document.getElementById(STYLE_ID);

                if (!style) {
                    style = document.createElement('style');
                    style.id = STYLE_ID;
                    document.head.appendChild(style);
                }

                // Append CSS rules (does NOT overwrite existing ones)
                // TEST - Show Variant
                
                style.appendChild(
                    document.createTextNode(`
                    /* ${STYLE_ID} - Nav Category L2 Spacing Reduction */

.menu-drawer__menu--grandchildlist li {
    margin-bottom: 17px;
}
                    `)
                );

                console.log(`Showing ${TEST_ID} Variant (Triggered on Menu Open)`);

            } else {
                // Show control
                // NO CHANGES DO NOTHING
                console.log(`Showing ${TEST_ID} Control (Triggered on Menu Open)`);
            }

        } catch (error) {
            // Always fail gracefully - show control experience on error
            console.error(`Shoplift test ${TEST_ID} failed:`, error);
        }
    }

    // If menu already open (edge case)
    if (drawerDetails.hasAttribute('open')) {
        handleMenuOpen();
        return;
    }

    // Observe for menu open (manual trigger)
    var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {

            var mutation = mutations[i];

            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {

                if (drawerDetails.hasAttribute('open')) {
                    observer.disconnect();
                    handleMenuOpen();
                    return;
                }
            }
        }
    });

    observer.observe(drawerDetails, { attributes: true });
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs = 5000) {
    const start = Date.now();

    const tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => whenShopliftReady(initTestCHS_126));
} else {
    whenShopliftReady(initTestCHS_126);
}



////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*==============================================================================
TEST ID: [CHS-130] [SEARCH] Auto Load More Button [ALL]
PLATFORM: Shoplift
DATE: 2026-05-26

GOAL:
When scrolling down a PLP/Collections/Search Page at the end of the results, once the Load More button enters the screen view this code will update the buttons copy to "Loading More" automatically click the CTA to load the following set of results.

KEY INSIGHT:
Target is specific by URL

BEHAVIOR:
- will update the CTA "Load More" copy to "Loading More"
- Only triggers Load More CTAs when they are on viewable on screen 
- Observes class attribute as lightweight fallback (future-safe)
==============================================================================*/

// Initialize test
async function initTestCHS_130() {
    
    // Configuration
    const TEST_ID = 'CHS130';
    const HYPOTHESIS_ID = '019ead4c-0ed5-7638-95a8-5c0a21c89daf';
    let variantResult = null;

    // Guard - ensure Shoplift is available
    if (!window.shoplift) {
        console.warn('Shoplift not available');
        return;
    }

    // Targeting - SEARCH only
    if (!window.location.pathname.startsWith('/search')) {
        return;
    }

    try {
        // Check if visitor is in the variant group
        variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

        if (variantResult) {

            // Scroll trigger (behavioral gating)
            function waitForScrollNearLoadMore(callback) {

                var triggered = false;

                function checkScroll() {

                    if (triggered) {
                        return;
                    }

                    var button = document.querySelector('.button.button--black-outline');

                    if (!button) {
                        return;
                    }

                    var rect = button.getBoundingClientRect();

                    // Trigger just before button enters view
                    if (rect.top < window.innerHeight + 150) {

                        triggered = true;
                        window.removeEventListener('scroll', checkScroll);

                        console.log(TEST_ID + ' â†’ Scroll trigger met');

                        callback();
                    }
                }

                window.addEventListener('scroll', checkScroll);
            }

            // Delay execution until scroll condition met
            waitForScrollNearLoadMore(function() {

                // TEST - Show Variant          
                (function() {

                    // One-run guard
                    if (window[TEST_ID + '_INIT']) {
                        return;
                    }
                    window[TEST_ID + '_INIT'] = true;

                    var buttonSelector = '.button.button--black-outline';

                    // Check if element is in viewport
                    function isInViewport(el) {
                        if (!el) {
                            return false;
                        }

                        var rect = el.getBoundingClientRect();

                        if (rect.top < window.innerHeight && rect.bottom > 0) {
                            return true;
                        }

                        return false;
                    }

                    // Attempt click + update button copy
                    function tryClick(button) {
                        if (!button) {
                            return false;
                        }

                        if (button.disabled) {
                            return false;
                        }

                        if (isInViewport(button)) {

                            var label = button.querySelector('span');
                            if (label) {
                                label.textContent = 'Loading more';
                            } else {
                                button.textContent = 'Loading more';
                            }

                            button.click();
                            console.log(TEST_ID + ' â†’ Clicked Load More:', button);

                            return true;
                        }

                        return false;
                    }

                    // Fast retry burst
                    function clickWithRetry() {
                        var attempts = 0;
                        var maxAttempts = 5;

                        var retryInterval = setInterval(function() {

                            var button = document.querySelector(buttonSelector);
                            var success = tryClick(button);

                            if (success) {
                                clearInterval(retryInterval);
                            }

                            attempts = attempts + 1;

                            if (attempts >= maxAttempts) {
                                clearInterval(retryInterval);
                            }

                        }, 120);
                    }

                    // Initial run
                    function init() {
                        clickWithRetry();
                    }

                    init();

                    // Watch for new products loading
                    var mutationObserver = new MutationObserver(function(mutations) {

                        var shouldCheck = false;

                        mutations.forEach(function(mutation) {
                            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                                shouldCheck = true;
                            }
                        });

                        if (shouldCheck) {
                            setTimeout(function() {
                                clickWithRetry();
                            }, 100);
                        }

                    });

                    mutationObserver.observe(document.body, {
                        childList: true,
                        subtree: true
                    });

                    // Fallback guard
                    setInterval(function() {
                        clickWithRetry();
                    }, 800);

                })();

                console.log('Showing ' + TEST_ID + ' Variant (On Scroll Trigger)');

            });

        } else {
            // Show control
            // NO CHANGES DO NOTHING
            console.log(`Showing ${TEST_ID} Control`);
        }

    } catch (error) {
        // Always fail gracefully - show control experience on error
        console.error(`Shoplift test ${TEST_ID} failed:`, error);
    }
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs) {

    if (!timeoutMs) {
        timeoutMs = 5000;
    }

    var start = Date.now();

    var tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        whenShopliftReady(initTestCHS_130);
    });
} else {
    whenShopliftReady(initTestCHS_130);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*==============================================================================
TEST ID: CHS-131 [Cart] Horizontal Checkout CTAs [ALL]
PLATFORM: Shoplift
DATE: 2026-05-26

GOAL:
Remove `.additional-checkout-buttons--vertical` so Shopify applies native
horizontal layout for Shop Pay / PayPal buttons.

KEY INSIGHT:
Layout is controlled by wrapper class, NOT shadow DOM.
No CSS overrides required.

BEHAVIOR:
- Runs once on load (primary path)
- Observes class attribute as lightweight fallback (future-safe)
==============================================================================*/

// Initialize test
async function initTestCHS_131() {
    
    // Configuration
    const TEST_ID = 'CHS131';
    const HYPOTHESIS_ID = '019ead2e-d170-7f4a-997f-5f9f53c88548';
    let variantResult = null;
    
    if (!window.shoplift) {
        console.warn('Shoplift not available');
        return;
    }

    // Targeting - Cart only
    //if (!window.location.pathname.startsWith('/cart')) {
    //    return;
    //}

    try {
        // Check if visitor is in the variant group
        variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

        if (variantResult) {
            
            // TEST - Show Variant
            (function () {

                //==========================
                // ONE-RUN GUARD
                //==========================
                if (window[TEST_ID + '_INIT']) {
                    return;
                }
                window[TEST_ID + '_INIT'] = true;

                //==========================
                // CORE FUNCTION
                //==========================
                function removeVerticalClass() {
                    var el = document.querySelector('.additional-checkout-buttons');

                    if (!el) return;

                    if (el.classList.contains('additional-checkout-buttons--vertical')) {
                        el.classList.remove('additional-checkout-buttons--vertical');

                        console.log(TEST_ID + ' Removed vertical class');
                    }
                }

                //==========================
                // INIT FUNCTION
                //==========================
                function init() {
                    var el = document.querySelector('.additional-checkout-buttons');

                    if (!el) return;

                    removeVerticalClass();

                    //==========================
                    // LIGHTWEIGHT FALLBACK
                    //==========================
                    var observer = new MutationObserver(function () {
                        removeVerticalClass();
                    });

                    observer.observe(el, {
                        attributes: true,
                        attributeFilter: ['class']
                    });
                }

                //==========================
                // LOAD HANDLING
                //==========================
                if (document.readyState === 'complete' || document.readyState === 'interactive') {
                    init();
                } else {
                    document.addEventListener('DOMContentLoaded', init);
                }

            })();

            console.log(`Showing ${TEST_ID} Variant`);

        } else {
            // Show control
            // NO CHANGES DO NOTHING
            console.log(`Showing ${TEST_ID} Control`);
        }

    } catch (error) {
        // Always fail gracefully - show control experience on error
        console.error(`Shoplift test ${TEST_ID} failed:`, error);
    }
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs = 5000) {
    const start = Date.now();

    const tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => whenShopliftReady(initTestCHS_131));
} else {
    whenShopliftReady(initTestCHS_131);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*==============================================================================
TEST ID: [CHS-106D] [CART] Display Savings 20% and up [ALL]
PLATFORM: Shoplift
DATE: 2026-06

GOAL:
Calculates between listing and sales price savings if 20% or more.

BEHAVIOR:

- Inserts a CSS/span class for calculated savings %
- Updates on Cart refresh
- Excludes Socks or items with div class .list-unstyled
==============================================================================*/

// Initialize test
async function initTestCHS_106D() {

    // Configuration
    const TEST_ID = 'CHS106D';
    const HYPOTHESIS_ID = '019eb2bb-026a-7191-b0ef-a9203ef17ced';
    let variantResult = null;

    try {
        variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

        if (variantResult) {

            (function () {

                //==========================
                // ONE-RUN GUARD
                //==========================
                if (window[TEST_ID + '_INIT']) return;
                window[TEST_ID + '_INIT'] = true;


                //==========================
                // CSS INJECTION
                //==========================
                function injectStyles() {
                    var styleId = TEST_ID + '-CSS';
                    if (document.getElementById(styleId)) return;

                    var css = ''
                        + '.' + TEST_ID + '-savePercSlot {'
                        + '  color: #3ba029;'
                        + '  font-weight: bold;'
                        + '  white-space: nowrap;'
                        + '  display: none;'
                        + '}';

                    var styleEl = document.createElement('style');
                    styleEl.id = styleId;
                    styleEl.appendChild(document.createTextNode(css));
                    document.head.appendChild(styleEl);
                }


                //==========================
                // CALCULATE SAVINGS
                //==========================
                function calcSav(listPrice, salesPrice) {
                    var lp = parseFloat(listPrice);
                    var sp = parseFloat(salesPrice);

                    if (isNaN(lp)) return '';
                    if (isNaN(sp)) return '';
                    if (lp <= 0) return '';
                    if (sp < 0) return '';
                    if (sp >= lp) return '';

                    return Math.floor(((lp - sp) / lp) * 100);
                }


                //==========================
                // FIND SALE PRICE - First visible span
                //==========================
                function getSalePriceEl(container) {
                    var spans = container.querySelectorAll('span');

                    for (var i = 0; i < spans.length; i++) {
                        var span = spans[i];
                        if (!span) continue;

                        var cls = '';
                        if (typeof span.className === 'string') {
                            cls = span.className;
                        }

                        if (cls.indexOf(TEST_ID + '-savePercSlot') !== -1) continue;
                        if (cls.indexOf('visually-hidden') !== -1) continue;

                        return span;
                    }

                    return null;
                }

                //==========================
                // UPDATE SINGLE TILE
                //==========================
                function updateSavings(tile) {
                    if (!tile) return;

                    var container = tile.querySelector('.cart-items__details-price');
                    if (!container) return;

                    var slot = container.querySelector('.' + TEST_ID + '-savePercSlot');
                    if (!slot) {
                        container.insertAdjacentHTML(
                            'beforeend',
                            '<span class="' + TEST_ID + '-savePercSlot body-xs"></span>'
                        );
                        slot = container.querySelector('.' + TEST_ID + '-savePercSlot');
                    }

                    if (!slot) return;

                    var listEl = container.querySelector('s');
                    var saleEl = getSalePriceEl(container);

                    if (!listEl || !saleEl) {
                        slot.innerHTML = '';
                        slot.style.display = 'none';
                        return;
                    }

                    var listPrice = listEl.innerText.replace(/([^0-9\.])/g, '');
                    var salesPrice = saleEl.innerText.replace(/([^0-9\.])/g, '');

                    var discountPct = calcSav(listPrice, salesPrice);

                    if (discountPct !== '' && discountPct >= 20) {
                        slot.innerHTML = 'You Save ' + discountPct + '%';
                        slot.style.display = 'inline'; // âœ… FIXED
                    } else {
                        slot.innerHTML = '';
                        slot.style.display = 'none';
                    }
                }


                //==========================
                // UPDATE ALL TILES
                //==========================
                function updateSavingsAll() {
                    var tiles = document.querySelectorAll('.cart-items__details');

                    for (var i = 0; i < tiles.length; i++) {
                        var hasList = tiles[i].querySelector('.list-unstyled');
                        if (hasList) continue;
                        updateSavings(tiles[i]);
                    }
                }


                //==========================
                // OBSERVER (SAFE)
                //==========================
                function initObserver() {
                    var container = document.querySelector('.cart-items');
                    if (!container) return;

                    var isRunning = false;

                    var observer = new MutationObserver(function (mutations) {
                        if (isRunning) return;

                        var shouldRun = false;

                        for (var i = 0; i < mutations.length; i++) {
                            var m = mutations[i];

                            if (m.addedNodes.length > 0 || m.removedNodes.length > 0) {
                                shouldRun = true;
                                break;
                            }
                        }

                        if (!shouldRun) return;

                        isRunning = true;

                        setTimeout(function () {
                            updateSavingsAll();
                            isRunning = false;
                        }, 50);
                    });

                    observer.observe(container, {
                        childList: true,
                        subtree: true
                    });
                }


                //==========================
                // INIT
                //==========================
                function init() {
                    injectStyles();
                    updateSavingsAll();
                    initObserver();
                }

                init();

            })();

            console.log('Showing ' + TEST_ID + ' Variant');

        } else {
            console.log('Showing ' + TEST_ID + ' Control');
        }

    } catch (error) {
        console.error('Shoplift test ' + TEST_ID + ' failed:', error);
    }
}


//==========================
// SHOPLIFT READY CHECK
//==========================
function whenShopliftReady(cb, timeoutMs) {
    if (typeof timeoutMs !== 'number') {
        timeoutMs = 5000;
    }

    const start = Date.now();

    const tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        whenShopliftReady(initTestCHS_106D);
    });
} else {
    whenShopliftReady(initTestCHS_106D);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*==============================================================================
TEST ID: [CHS-129B] [Sitewide] Header/Nav Sales Red June
PLATFORM: Shoplift
DATE: 06/2026

GOAL:
Adds CSS to highlight Nav Sales Category in Red

KEY INSIGHT:
N/A

BEHAVIOR:
- Automatic Trigger
- Append CSS rules
==============================================================================*/

// Initialize test
async function initTestCHS_129B() {
	
	// Configuration
	const TEST_ID = 'CHS_129B';
	const HYPOTHESIS_ID = '019eb2d2-4f38-7079-93f2-53d3f325969f';
	let variantResult = null;
	
	if (!window.shoplift) {
	console.warn('Shoplift not available');
	return;
	}

	try {
	// Check if visitor is in the variant group
	variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

		if (variantResult) {
			// Create or reuse the canonical style CSS (append-safe)
			const STYLE_ID = `${TEST_ID}-CSS`;
			let style = document.getElementById(STYLE_ID);

			if (!style) {
				style = document.createElement('style');
				style.id = `${TEST_ID}-CSS`;
				document.head.appendChild(style);
			}

			// Append CSS rules (does NOT overwrite existing ones)
			// TEST - Show Variant
			
			style.appendChild(
				document.createTextNode(`
				/* ${style.id} - Nav Category Sales Red Highlight */

					li.menu-list__list-item:nth-child(7) .menu-list__link-title.caption {
						color: #D10707!important;
						}
				`)
			);
			console.log(`Showing ${TEST_ID} Variant`);
		} else {
			// Show control
			// NO CHANGES DO NOTHING
			console.log(`Showing ${TEST_ID} Control`);
		}
	} catch (error) {
		// Always fail gracefully - show control experience on error
		console.error(`Shoplift test ${TEST_ID} failed:`, error);
		}
		
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs = 5000) {
    const start = Date.now();

    const tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => whenShopliftReady(initTestCHS_129B));
} else {
    whenShopliftReady(initTestCHS_129B);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////